import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=7924b6dc&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=7924b6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924b6dc",
  null
  
)

export default component.exports